import { MetadataModel, SystemFeatures, UserModel } from '@/types';
import { createContext } from 'react';

export const SystemFeaturesContext = createContext<SystemFeatures>({ briefPosts: true, mediaGallery: true, googleTranslate: false });

export const MetadataContext = createContext<MetadataModel>({
  absolutePageUrl: '',
  culture: '',
  headSectionScripts: [''],
  languages: [{ language: '', languageUrl: '' }],
  metaDescription: '',
  openGraphDescription: '',
  openGraphPageTitle: '',
  pageId: 0,
  pageTitle: '',
  pageType: '',
  pageUrl: '',
  siteRootId: 0,
  isStub: false,
});

export const UserContext = createContext<UserModel>({});
